import React from 'react';

export function CheckIcon(): React.ReactElement {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#046A38" strokeWidth={2.5}>
      <path d="M20 6L9 17l-5-5"/>
    </svg>
  );
}
